import { render, staticRenderFns } from "./VehicleMonitoring.vue?vue&type=template&id=f0dea270"
import script from "./VehicleMonitoring.vue?vue&type=script&lang=js"
export * from "./VehicleMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports